/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BranchType } from '../models/BranchType';
import type { CapHpiDvlaDTO } from '../models/CapHpiDvlaDTO';
import type { EmailHtmlTemplateDto } from '../models/EmailHtmlTemplateDto';
import type { StockVideoDto } from '../models/StockVideoDto';
import type { UploadVideoResultDto } from '../models/UploadVideoResultDto';
import type { VideoLogAIRenderModel } from '../models/VideoLogAIRenderModel';
import type { VideoLogComponentDto } from '../models/VideoLogComponentDto';
import type { VideoLogCustomerTypes } from '../models/VideoLogCustomerTypes';
import type { VideoLogDto } from '../models/VideoLogDto';
import type { VideoLogDtoPagedListData } from '../models/VideoLogDtoPagedListData';
import type { VideoLogInput } from '../models/VideoLogInput';
import type { VideoLogRenderModel } from '../models/VideoLogRenderModel';
import type { VideoLogUserEmailDataModel } from '../models/VideoLogUserEmailDataModel';
import type { VideoNumberEnum } from '../models/VideoNumberEnum';
import type { WebHookResponse } from '../models/WebHookResponse';
import type { WipLookUpDto } from '../models/WipLookUpDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class VideoLogService {

  /**
   * @param customerType
 *
 * 1 = Sales
 *
 * 2 = Service
 *
 * 3 = Template
   * @param branch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @param userId 
   * @param from 
   * @param to 
   * @param enquiryCrmId 
   * @param skipPagination Пропустить пагинацию
   * @param page Страница
   * @param maxCount Максимально количество записей на странице
   * @returns VideoLogDtoPagedListData Success
   * @throws ApiError
   */
  public static getVideoLogs(
customerType?: VideoLogCustomerTypes,
branch?: BranchType,
userId?: Array<number>,
from?: string,
to?: string,
enquiryCrmId?: number,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<VideoLogDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/video-logs',
      query: {
        'CustomerType': customerType,
        'Branch': branch,
        'UserId': userId,
        'From': from,
        'To': to,
        'EnquiryCrmId': enquiryCrmId,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postVideoLogs(
requestBody?: VideoLogInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/video-logs',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @returns VideoLogDto Success
   * @throws ApiError
   */
  public static getVideoLogs1(
id: number,
): CancelablePromise<VideoLogDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/video-logs/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putVideoLogs(
id: number,
requestBody?: VideoLogInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/video-logs/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteVideoLogs(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/video-logs/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param isWithoutConcernVideos 
   * @returns VideoLogComponentDto Success
   * @throws ApiError
   */
  public static getVideoLogsSoHeaderVideos(
id: number,
isWithoutConcernVideos: boolean = false,
): CancelablePromise<VideoLogComponentDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/video-logs/{id}/so-header-videos',
      path: {
        'id': id,
      },
      query: {
        'isWithoutConcernVideos': isWithoutConcernVideos,
      },
    });
  }

  /**
   * @param id 
   * @param formData 
   * @returns any Success
   * @throws ApiError
   */
  public static postVideoLogsAudio(
id: number,
formData?: {
Audio: Blob;
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/video-logs/{id}/audio',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param id 
   * @param formData 
   * @returns UploadVideoResultDto Success
   * @throws ApiError
   */
  public static postVideoLogsVideos(
id: number,
formData?: {
VideoNumber: VideoNumberEnum;
Video: Blob;
},
): CancelablePromise<UploadVideoResultDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/video-logs/{id}/videos',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param id 
   * @param videoNumber
 *
 * 1 = FirstVideo
 *
 * 2 = SecondVideo
 *
 * 3 = ThirdVideo
   * @returns any Success
   * @throws ApiError
   */
  public static deleteVideoLogsVideos(
id: number,
videoNumber: VideoNumberEnum,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/video-logs/{id}/videos/{videoNumber}',
      path: {
        'id': id,
        'videoNumber': videoNumber,
      },
    });
  }

  /**
   * @param id 
   * @param formData 
   * @returns any Success
   * @throws ApiError
   */
  public static postVideoLogsYoutubeVideo(
id: number,
formData?: {
VideoNumber: VideoNumberEnum;
Video: Blob;
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/video-logs/{id}/youtube-video',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteVideoLogsYoutubeVideo(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/video-logs/{id}/youtube-video',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postVideoLogsRenderAsset(
requestBody?: VideoLogRenderModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/video-logs/render-asset',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postVideoLogsRenderAiSpeechAsset(
requestBody?: VideoLogAIRenderModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/video-logs/render-ai-speech-asset',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postVideoLogsEmailUserInfo(
requestBody?: VideoLogUserEmailDataModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/video-logs/email-user-info',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static postVideoLogsSendEmail(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/video-logs/{id}/send-email',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @returns EmailHtmlTemplateDto Success
   * @throws ApiError
   */
  public static getVideoLogsPreviewEmail(
id: number,
): CancelablePromise<EmailHtmlTemplateDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/video-logs/{id}/preview-email',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static postVideoLogsSendSms(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/video-logs/{id}/send-sms',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param regNo 
   * @param stockNo 
   * @returns CapHpiDvlaDTO Success
   * @throws ApiError
   */
  public static getVideoLogsLookUpVehicle(
regNo?: string,
stockNo?: string,
): CancelablePromise<CapHpiDvlaDTO> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/video-logs/look-up-vehicle',
      query: {
        'regNo': regNo,
        'stockNo': stockNo,
      },
    });
  }

  /**
   * @param wipNo 
   * @param branch 
   * @param regNo 
   * @returns WipLookUpDto Success
   * @throws ApiError
   */
  public static getVideoLogsLookUpWipNo(
wipNo?: number,
branch?: number,
regNo?: string,
): CancelablePromise<Array<WipLookUpDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/video-logs/look-up-wip-no',
      query: {
        'wipNo': wipNo,
        'branch': branch,
        'regNo': regNo,
      },
    });
  }

  /**
   * @param id 
   * @returns StockVideoDto Success
   * @throws ApiError
   */
  public static getVideoLogsStockVideos(
id: number,
): CancelablePromise<Array<StockVideoDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/video-logs/{id}/stock-videos',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param videoStockId 
   * @returns any Success
   * @throws ApiError
   */
  public static putVideoLogsStockVideos(
id: number,
videoStockId: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/video-logs/{id}/stock-videos/{videoStockId}',
      path: {
        'id': id,
        'videoStockId': videoStockId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postVideoLogsRenderWebhook(
requestBody?: WebHookResponse,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/video-logs/render-webhook',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postVideoLogsRenderAiSpeechWebhook(
requestBody?: WebHookResponse,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/video-logs/render-ai-speech-webhook',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public static postVideoLogsWebhookAws(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/video-logs/webhook-aws',
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postVideoLogsDeleteYoutubeVideo(
requestBody?: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/video-logs/delete-youtube-video',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

}
